var $ = require('jquery');
var $script = require('scriptjs');

var r2PlayerJS = '//sf.nm-ovp.nelonenmedia.fi/player/stable/ruutu-player-loader.js';

module.exports = function manualRuutuEmbed(el) {
    $script(r2PlayerJS, function () {
        if (!el)
            el = $('[data-ruutu-video]').not('.ruutu-video');

        $(el).each(function () {
            var autoplay = false,
                $this = $(this),
                videoId = $this.data('ruutu-video'),
                id = 'player-placeholder-' + (Math.random() * 100000 | 0);

            $this.attr('id', id).addClass('ruutu-video');
            if($this.hasClass('autoplay')) {
                autoplay = true;
            }
            RP.embedPlayer({
                containerId: id,
                width: 640,
                height: 360,
                mxmlcUri: 'https://gatling.nelonenmedia.fi/media-xml-cache?id=' + videoId + '&v=2',
                autoplay: autoplay,
                loop: false,
                responsive: true,
                vsite: 'LIIGA',
                ns_site: 'sanoma-external',
                fw_site: 'Embedded'
            });
        });
    });
};



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/manualruutuembed.js
// module id = 8
// module chunks = 0